<template>

        <el-menu
                default-active="2"
                class="el-menu-vertical-demo"
                :collapse="isCollapse"
                @open="handleOpen"
                @close="handleClose"
                unique-opened="true"
                background-color="#fff"
        >
            <el-sub-menu index="2">
                <template #title >任务管理</template>
<!--              <div v-for="(value,key) in this.authList" :key="key">-->
                <el-menu-item index="2-1" @click="toOrder(0)" >
                  <template v-slot:title>
                    <span class="iconfont icon-24gl-fileText" style="margin-right: 5px"></span>
                    任务创建
                  </template>
                </el-menu-item>
                <el-menu-item index="2-2" @click="toOrder2(1)" >
                  <template v-slot:title>
                    <span class="iconfont icon-fenpei" style="margin-right: 5px"></span>
                    任务分配
                  </template>
                </el-menu-item>
                <el-menu-item index="2-3" @click="toOrderGet" >
                  <template v-slot:title>
                    <span class="iconfont icon-lingqu" style="margin-right: 5px"></span>
                    任务领取
                  </template>
                </el-menu-item>
<!--              </div>-->
            </el-sub-menu>

            <el-sub-menu index="1" >
                <template #title >检测报告管理</template>
<!--                <div v-for="(value,key) in this.authList" :key="key">-->
                <el-menu-item index="1-6" >
                    <template v-slot:title >
                        <span class="iconfont icon-chujian" style="margin-right: 5px"></span>
                        <span @click="toDetec">检测报告初检</span>
                    </template>
                </el-menu-item>
                <el-menu-item index="1-1" >
                    <template v-slot:title >
                        <span class="iconfont icon-bianzhirenwu" style="margin-right: 5px"></span>
                        <span @click="toWeave">检测报告编制</span>
                    </template>
                </el-menu-item>
                <el-menu-item index="1-2" >
                    <template v-slot:title>
                        <span class="iconfont icon-shenhe" style="margin-right: 5px"></span>
                        <span @click="toAudit">检测报告审核</span>
                    </template>
                </el-menu-item>
                <el-menu-item index="1-3" >
                    <template v-slot:title>
                        <span class="iconfont icon-xian-buguize-yanzheng" style="margin-right: 5px"></span>
                        <span @click="toApprove">
                         检测报告批准
                        </span>
                    </template>
                </el-menu-item>
                <el-menu-item index="1-4" >
                    <template v-slot:title>
                        <span class="iconfont icon-chaxun" style="margin-right: 5px"></span>
                        <span @click="toQuery">
                         检测报告查询
                        </span>
                    </template>
                </el-menu-item>
                <el-menu-item index="1-5" >
                    <template v-slot:title>
                        <span class="iconfont icon-shangchuan" style="margin-right: 5px"></span>
                        <span @click="toUpload">
                         检测数据上传
                        </span>
                    </template>
                </el-menu-item>
<!--                </div>-->
             </el-sub-menu>
            <el-sub-menu index="4">
                <template #title>业务管理</template>
                <el-menu-item index="4-1" @click="toDevice" >
                    <template v-slot:title>
                        <span class="iconfont icon-office-building" style="margin-right: 10px"></span>
                        设备管理
                    </template>
                </el-menu-item>
                <el-menu-item index="4-5" @click="toDeviceStatus" >
                    <template v-slot:title>
                        <span class="iconfont icon-shebeizhuangtai" style="margin-right: 5px"></span>
                        <span>设备状态</span>
                    </template>
                </el-menu-item>
                <el-menu-item index="4-2" @click="toTemplate" >
                    <template v-slot:title>
                        <span class="iconfont icon-caidan" style="margin-right: 5px"></span>
                        <span>检测模板管理</span>
                    </template>
                </el-menu-item>
                <el-menu-item index="4-3" @click="toSeal" >
                    <template v-slot:title>
                        <span class="iconfont icon-shenhe" style="margin-right: 5px"></span>
                        <span>电子印章上传</span>
                    </template>
                </el-menu-item>
                <el-menu-item index="4-4" @click="toState" >
                    <template v-slot:title>
                        <span class="iconfont icon-shengming" style="margin-right: 5px"></span>
                        <span>符合性声明</span>
                    </template>
                </el-menu-item>
            </el-sub-menu>
            <el-sub-menu index="3">
                <template #title>系统设置</template>
                <el-menu-item index="3-1" @click="toRole" >
                  <template v-slot:title>
                    <span class="iconfont icon-quanxian" style="margin-right: 5px"></span>
                    权限管理
                  </template>
                </el-menu-item>
                <el-menu-item index="3-2" @click="toUser" >
                  <template v-slot:title>
                    <span class="iconfont icon-jurassic_user" style="margin-right: 5px"></span>
                    用户管理
                  </template>

                </el-menu-item>
<!--                <el-menu-item index="3-3" @click="toArea" >-->
<!--                  <template v-slot:title>-->
<!--                    <span class="iconfont icon-location" style="margin-right: 5px"></span>-->
<!--                    区域管理-->
<!--                  </template>-->

<!--                </el-menu-item>-->
                <el-menu-item index="3-4" @click="toTool" >
                    <template v-slot:title>
                        <span class="iconfont icon-gongjuxiang" style="margin-right: 5px"></span>
                        工具箱管理
                    </template>

                </el-menu-item>
                <el-menu-item index="3-5" @click="toCap" >
                    <template v-slot:title>
                        <span class="iconfont icon-a-005_anquanmao" style="margin-right: 5px"></span>
                        安全帽管理
                    </template>

                </el-menu-item>
            </el-sub-menu>


        </el-menu>
</template>

<script>
    export default {
        name: "LCAside",
        data(){
            return{
                isCollapse:false,
                authorityId:'',
                authList:[],
                timeT:'',
            }
        },
        created(){
          this.getList()
            // this.load()
        },

        methods: {
          getList(){
            this.authList = [];
            let user = sessionStorage.getItem('authorityId'); //1,2,3
            // let arr = user.split(",")
            console.log(user)
            // console.log(user.length)
            console.log(typeof user)
            // console.log(user.length)
            if(user.length > 1){
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.authList = user.split(",");
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              //   this.authList = Object.values(this.authList)
              console.log(user.split(","))
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              console.log(typeof this.list)
              console.log(typeof Object.values(this.authList))
              console.log(typeof user.split(","))
              console.log(this.authList)

              // for (( value,index) in this.authList) {
              //   console.log(this.authList)
              // }

              console.log(this.authList[0])
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            } else if (user.length === 1){
              this.authList = user
              console.log(user.authorityId)
            }
            // return this.$store.getters.getCurrentPathName;
          },
            load() {
                console.log("-----1111");

                this.timeT = setTimeout(() => {
                this.authorityId = sessionStorage.getItem('authorityId');
                    console.log(this.authorityId+"-----aside---authorityId");
                    // Object.keys(this.user).forEach((key,index) => {
                    //     console.log( key,index, this.user[key])
                    // })
                // if(this.user!=null){
                //     console.log(this.user.authorityId);
                    // if(this.user.authorityId.length>1){
                    //     this.authList = this.user.authorityId.split(",");
                    // }else this.authList.push(this.user.authorityId);
                // }

                }, 1000);
                // clearTimeout(this.timeT);
            },
            handleOpen(key, keyPath) {
                console.log(key, keyPath);
            },
            handleClose(key, keyPath) {
                console.log(key, keyPath);
            },
            toDevice() {
              if (this.authList.indexOf('14') !== -1) {
                this.$router.push({path:'Device'})
              } else {
                this.$router.push({path:'home', query:{}});
                this.$message({
                  message: '无权限！',
                  type: 'error'
                });
              }

            },
            toDeviceStatus(){
                this.$router.push({path:'DeviceStatus'})
            },
            toTemplate() {
              if (this.authList.indexOf('15') !== -1) {
                this.$router.push({path:'Template', query:{}})
              } else {
                this.$router.push({path:'home', query:{}});
                this.$message({
                  message: '无权限！',
                  type: 'error'
                });
              }

            },
            toDetec(){
                if (this.authList.indexOf('4') !== -1) {
                    localStorage.setItem("currentPathName", "检测报告初检") ;
                    this.$router.push({path:'startDetect', query:{}})
                } else {
                    this.$router.push({path:'home', query:{}});
                    this.$message({
                        message: '无权限！',
                        type: 'error'
                    });
                }

            },
            toWeave() {
              if (this.authList.indexOf('5') !== -1) {
                localStorage.setItem("currentPathName", "检测报告编制") ;
                this.$router.push({path:'record', query:{RecordFlag : 0}})
              } else {
                this.$router.push({path:'home', query:{}});
                this.$message({
                  message: '无权限！',
                  type: 'error'
                });
              }

            },
            toAudit() {
              if (this.authList.indexOf('6') !== -1) {
                localStorage.setItem("currentPathName", "检测报告审核") ;
                this.$router.push({path:'record', query:{RecordFlag : 5}})
              } else {
                this.$router.push({path:'home', query:{}});
                this.$message({
                  message: '无权限！',
                  type: 'error'
                });
              }
            },
            toApprove() {
              if (this.authList.indexOf('7') !== -1) {
                localStorage.setItem("currentPathName", "检测报告批准") ;
                this.$router.push({path:'record', query:{RecordFlag : 2}})
              } else {
                this.$router.push({path:'home', query:{}});
                this.$message({
                  message: '无权限！',
                  type: 'error'
                });
              }

            },
          toQuery() {
            if (this.authList.indexOf('8') !== -1) {
              localStorage.setItem("currentPathName", "检测报告查询") ;
              this.$router.push({path:'record', query:{RecordFlag : 3}})
            } else {
              this.$router.push({path:'home', query:{}});
              this.$message({
                message: '无权限！',
                type: 'error'
              });
            }

          },
          toUpload() {
            if (this.authList.indexOf('9') !== -1) {
              localStorage.setItem("currentPathName", "检测报告上传") ;
              this.$router.push({path:'record', query:{RecordFlag : 4}})
            } else {
              this.$router.push({path:'home', query:{}});
              this.$message({
                message: '无权限！',
                type: 'error'
              });
            }

          },
            toRole() {
              if (this.authList.indexOf('11') !== -1) {
                this.$router.push({path:'Role', query:{}})
                // if (this.authList.toString().split(",").findIndex(item => item === '15')) {
                //   console.log(this.authList.toString().split(","))
                //   console.log(this.authList.indexOf('12'))
                //   console.log(typeof this.authList.toString().split(","))
                //     console.log("真")
                //   } else {
                //     console.log("假")
                //   }
              } else {
                console.log(this.authList.findIndex(item => item === 11))
                console.log(this.authList.toString())
                // if (this.authList.findIndex(item => item === 11)) {
                //   console.log("真")
                // } else {
                //   console.log("假")
                // }
                this.$router.push({path:'home', query:{}});
                this.$message({
                  message: '无权限！',
                  type: 'error'
                });
              }
            },
            toUser() {
              if (this.authList.indexOf('12') !== -1) {
                this.$router.push({path:'UserList', query:{}})
              } else {
                this.$router.push({path:'home', query:{}});
                this.$message({
                  message: '无权限！',
                  type: 'error'
                });
              }
            },
            toArea() {
              if (this.authList.indexOf('13') !== -1) {
                this.$router.push({path:'AreaSetIndex', query:{}})
              } else {
                this.$router.push({path:'home', query:{}});
                this.$message({
                  message: '无权限！',
                  type: 'error'
                });
              }
            },
            toTool(){
                if (this.authList.indexOf('19') !== -1) {
                    this.$router.push({path:'Tool', query:{}})
                } else {
                    this.$router.push({path:'home', query:{}});
                    this.$message({
                        message: '无权限！',
                        type: 'error'
                    });
                }
            },
          toCap(){
            if (this.authList.indexOf('21') !== -1) {
              this.$router.push({path:'Cap', query:{}})
            } else {
              this.$router.push({path:'home', query:{}});
              this.$message({
                message: '无权限！',
                type: 'error'
              });
            }
          },
            toOrder(show) {
              console.log(this.authList)
              // for (let i = 0; i < this.authList.length; i++) {
              //   console.log(this.authList[i])
                localStorage.setItem("currentPathName", "任务创建") ;
                if (this.authList.indexOf('1') !== -1) {
                  this.$router.push({path:'Order', query:{show:show}})
                } else {
                  this.$router.push({path:'home', query:{}});
                  this.$message({
                    message: '无权限！',
                    type: 'error'
                  });
                }
              // }
            },
            toOrder2(show) {
                localStorage.setItem("currentPathName", "任务分配") ;
              if (this.authList.indexOf('2') !== -1) {
                this.$router.push({path:'Order', query:{show:show}})
              } else {
                this.$router.push({path:'home', query:{}});
                this.$message({
                  message: '无权限！',
                  type: 'error'
                });
              }

            },
          toOrderGet() {
            if (this.authList.indexOf('3') !== -1) {
              this.$router.push({path:'OrderGet', query:{}})
            } else {
              this.$router.push({path:'home', query:{}});
              this.$message({
                message: '无权限！',
                type: 'error'
              });
            }

          },
            toSeal() {
                if (this.authList.indexOf('16') !== -1) {
                    this.$router.push({path:'Seal', query:{}})
                } else {
                    this.$router.push({path:'home', query:{}});
                    this.$message({
                        message: '无权限！',
                        type: 'error'
                    });
                }

            },
            toState(){
                if (this.authList.indexOf('18') !== -1) {
                    this.$router.push({path:'State', query:{}})
                } else {
                    this.$router.push({path:'home', query:{}});
                    this.$message({
                        message: '无权限！',
                        type: 'error'
                    });
                }
            },
        },
        // beforeDestroy() {
        //     clearTimeout(this.timeT);
        // },
    }
</script>

<style scoped>
    .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 200px;
        min-height: 400px;
    }
</style>